import(/* webpackMode: "eager" */ "/home/ubuntu/download/6988256b921dc900142cd459/website_project/src/app/about/page.tsx");
